import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Events, ModalController, LoadingController, PopoverController } from 'ionic-angular';
import { AppState } from '../../config/state';
import { EventsProvider } from '../../providers/events/events';
import moment from 'moment';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { HidScannerProvider } from '../../providers/hid-scanner/hid-scanner';
import { PatronProvider } from '../../providers/patron/patron';
import { CoPatronSignupInfoModalPage } from '../co-patron-signup-info-modal/co-patron-signup-info-modal';
import { LocationsProvider } from '../../providers/locations/locations';
import { Observable } from 'rxjs';
import { CoBulkAddAttendancePopoverComponent } from '../../components/co-bulk-add-attendance-popover/co-bulk-add-attendance-popover';
import { CoCalendarComponent } from '../../components/co-calendar/co-calendar';
import { CoLoginComponent } from '../../components/co-login/co-login';
import { LoginProvider } from '../../providers/login/login';

/**
 * Generated class for the CoEventCheckinPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-co-event-checkin',
  templateUrl: 'co-event-checkin.html',
})

export class CoEventCheckinPage {
  private rawEvents = [];
  private rawRegistrants = [];
  private randomEvents = [];
  private todaysDate = '';
  private checkInStage = 'choose';
  private selectedEvent = {};
  private guestTotal = {};
  private emailAddress = '';
  private hidSubscription: any;
	private eventList = [];
	private searchTerm: string;
	private agesList: any = [];
	private rawdate: any;
	private currentLocation: any;
	private branchList: Array<any>;
	private currentLocationId: number = null;
	private guestCount: number = 0;
	private patronCount: number = 0;
	private isEditingPatron: boolean = false;
	private currentEditPatronNumber: number = -1;
	private registeredEventsAttendList: any;
	private currentEventAttendanceList = [];
	private attendanceGroupList = [];
	private newRegistrant: any = {barcode: '', firstName: '', lastName: '', email: '', ageGroup: '', guests: [], isGuest: false};
	private oldPatronInfo: any;
  constructor(public navCtrl: NavController, public navParams: NavParams, private state: AppState, private eventsProvider: EventsProvider, private events: Events, private toast: ToastAlertsProvider, private hidScanner: HidScannerProvider, private patronProvider : PatronProvider, private modalCtrl : ModalController, private loading : LoadingController, private location : LocationsProvider, private popoverCtrl : PopoverController, private login : LoginProvider) {
	this.todaysDate = moment().format("YYYY-MM-DD HH:mm:ss");
	this.rawdate = moment();
	// this.currentLocationId = this.state.locationId;

	let loader = this.loading.create({content: "Getting location..."});
	if (!this.state.demo || this.state.staff) loader.present();

	if (this.state.demo && !this.state.staff){
		this.location.getLocations().then(locations => {
			this.branchList = locations;
			this.currentLocation = locations.find(b => b.id == this.state.locationId);
			this.currentLocationId = this.currentLocation.id;
			this.getEvents();
		});
	} else {
		this.location.getUserLocation().then(coords =>{
			if (coords && coords.lat !== ''){
				this.location.getNearestLocations(coords.lat, coords.lng).then(l=>{
					// console.log(l)
					loader.dismiss().catch(err=>{});
					this.currentLocation = l[0];
					this.currentLocationId = l[0].id;
					this.branchList = l.sort((a, b) => a.name.localeCompare(b.name));
					this.getEvents();
				});
			} else {
				this.location.getLocations().then(locations => {
					loader.dismiss().catch(err=>{});
					this.branchList = locations;
					this.currentLocation = locations.find(b => b.id == this.state.locationId);
					this.currentLocationId = this.currentLocation.id;
					this.getEvents();
				})
			}
		}).catch(err =>{
			this.location.getLocations().then(locations => {
				loader.dismiss().catch(err=>{});
				this.branchList = locations;
				this.currentLocation = locations.find(b => b.id == this.state.locationId);
				this.currentLocationId = this.currentLocation.id;
				this.getEvents();
			});
		});
	}
	this.hidSubscription = this.hidScanner.scan.subscribe(value => {
		if(this.checkInStage!=='checkin')return;
		this.newRegistrant.barcode = value;
	  this.events.publish('closeKeyboard');
	});
	this.hidScanner.start();
	this.eventsProvider.getAgeGroups().then(list =>{
		this.agesList = list;
		this.agesList.forEach(e => {
			this.guestTotal[e.id]=0;
		});

	});
}
	changeDate(forward){
		if (forward){
			this.rawdate = this.rawdate.add(1, 'day');
			this.todaysDate = this.rawdate.format("YYYY-MM-DD HH:mm:ss")
		} else {
			this.rawdate = this.rawdate.subtract(1, 'day');
			this.todaysDate = this.rawdate.format("YYYY-MM-DD HH:mm:ss")
		}
		this.getEvents();
	}
	changeToToday(){
		this.rawdate = moment();
		this.todaysDate = this.rawdate.format("YYYY-MM-DD HH:mm:ss");
		this.getEvents();
	}
	openDatePicker(){
    let popover = this.popoverCtrl.create(CoCalendarComponent, { popup: true, range: false }, { cssClass: 'date-time-popover' });
    popover.present();

    popover.onDidDismiss(data => {
      if(data && data.date){
				this.rawdate = moment(data.date, "DD MMMM YYYY");
				this.todaysDate = this.rawdate.format("YYYY-MM-DD HH:mm:ss");

				this.getEvents();
      }
    });
  }
	getEvents(silent?){
		this.currentLocation = this.branchList.find(b => b.id == this.currentLocationId);
		let loader = this.loading.create({content: "Retrieving events..."});
		if (!silent) loader.present();
		this.eventsProvider.getEventsNoCache(`startDate: "${this.rawdate.startOf('day').format("YYYY-MM-DD HH:mm:ss")}", endDate: "${this.rawdate.endOf('day').format("YYYY-MM-DD HH:mm:ss")}", locationId: ${this.currentLocationId}`).then(events=>{
			// console.log(events.allEvents);
			events.allEvents.map(event =>{
				if (!event.registrationOpens){
					this.eventsProvider.getEventAttendees(event).then(attendance =>{
						event.attendance = attendance.getEventAttendance;
						return this.ageGroupInfoRaw(event);
					});
				}
			});
			let list = events.allEvents;
			// console.log(list);
			this.rawEvents = list;
			this.eventList = list;
			this.randomEvents = list;
			if (!silent) loader.dismiss().catch(err=>{});
		});
	}
	getDetailedCheckinNumbers(event){
		if (event.registrationOpens){
			this.patronCount = event.totalAttendance
			this.guestCount = this.currentEventAttendanceList.filter(r =>{return r.isGuest}).length;
			return event.totalAttendance;
		} else {
			this.patronCount = this.currentEventAttendanceList.filter(r =>{return !r.isGuest}).length;
			this.guestCount = this.currentEventAttendanceList.filter(r =>{return r.isGuest}).length;
			return this.currentEventAttendanceList.length;
		}
	}
	eventStatus(event){
		if (moment().isAfter(moment(event.eventEnd))) return 'Event has already ended';
		if (moment().isBetween(moment(event.eventStart).subtract(2, 'hours'), moment(event.eventStart))) return `Event starts in ${moment().to(moment(event.eventStart))}`
		if (moment().isBetween(moment(event.eventStart), moment(event.eventEnd))) return 'Event in progress';
		return '';
	}
	eventPassed(event){
		if (moment().isAfter(moment(event.eventEnd))) return true;
		return false;
	}
  goToCheckinScreen(event, findPatron?){

		if (event.registrationOpens){ // FOR REGISTERED EVENTS goes straight to the attendees list with registered list and attendance list joined
			this.currentEventAttendanceList = [];
			this.newRegistrant = {barcode: '', firstName: '', lastName: '', email: '', ageGroup: '', guests: [], isGuest: false}
			this.registeredEventsAttendList = [];
			this.currentEditPatronNumber = -1;
			this.eventsProvider.getEventRegistrants(event.eventId).then(list =>{ //FIRST GET REGISTRATION LIST FROM EVENT
				this.eventsProvider.getEventAttendees(event).then( regList =>{
						this.registeredEventsAttendList = regList.getEventAttendance;
						// // console.log(list, regList);
						list = list.getEventRegistrants.map(r =>{  // LOOP THROUGH EVENT REGISTRANTS FIRST, GETTING CONTACT INFO
							let registrant = regList.getEventAttendance.find(l =>{return l.registrationId == r.registrationId}); //THEN FIND THE CORRESPONDING ATTENDEE TO MATCH THEM TOGETHER
							// console.log(registrant, r);
							r.ageGroup = this.agesList.find(a => {return a.nameSingular.toLowerCase() == r.age.toLowerCase()}).id;
							if (!r.guests) r.guests = [];
							if (registrant){
								if (registrant.id) r.attendanceId = registrant.id;
								r.checkedIn = registrant.checkedIn;
								r.barcode = registrant.libraryCard;
								r.firstName = registrant.firstName;
								r.lastName = registrant.lastName;
							}
							return r;
						});
						this.currentEventAttendanceList = list;
						this.checkInStage='registrants';
						this.selectedEvent = event;

				})
			});
		} else {
			//For unregistered events goes to new attendant screen
			if (!this.selectedEvent['eventId']) this.selectedEvent = event;
			if (findPatron){
				if (this.state.patron && !this.state.staff && !this.state.isRoam){
					let signup = this.modalCtrl.create(CoPatronSignupInfoModalPage, {ages: this.agesList, patron: this.state.patron});
						signup.present();
						signup.onDidDismiss(data =>{
							if (data && data.patron){
								// this.goToRegistrantsList(false);
								this.newRegistrant = data.patron;
								this.checkinSinglePatron();
							}
						});
				} else {
					let modal = this.modalCtrl.create(CoLoginComponent, { pinless: this.state.pinless, login: (barcode, pin) => this.patronProvider.getSummaryDetails(barcode, pin) }, { cssClass: `loginModalBase`, enableBackdropDismiss: false });
					modal.present();
					modal.onDidDismiss(res => {
						if (res && res.id){
							let signup = this.modalCtrl.create(CoPatronSignupInfoModalPage, {ages: this.agesList, patron: res});
							signup.present();
							signup.onDidDismiss(data =>{
								if (data && data.patron){
									// this.goToRegistrantsList(false);
									this.newRegistrant = data.patron;
									this.checkinSinglePatron();
								}
							});
						}
					});
				}
			} else {
				let signup = this.modalCtrl.create(CoPatronSignupInfoModalPage, {ages: this.agesList});
				signup.present();

				signup.onDidDismiss(data =>{
					if (data && data.patron){
						// this.goToRegistrantsList(false);
						this.newRegistrant = data.patron;
						this.checkinSinglePatron();
					}
				});
			}

		}
	}
	openScanCard() {

		let lintWindow: any = window;
		if(lintWindow.cordova && lintWindow.cordova.plugins) {
		  lintWindow.cordova.plugins.CoScanner.scan({
			color: "#ff00ff",
			message: "",
			isISBN: false
		  }, (data) => {
			if (data.success == true) {
				this.newRegistrant.barcode = data.result;
				setTimeout(()=>this.cardCheckin(), 10);
			}
		  }, (error) => {
			if (error.error != 'USER_CANCELLED') {
			  this.toast.showAlert('', error.message);
			}
		  });
		}

	}
	createNewGuest(){
		let modal = this.modalCtrl.create(CoPatronSignupInfoModalPage, {ages: this.agesList});
		modal.present();

		modal.onDidDismiss(guest =>{
			if (guest){
				this.newRegistrant.guests.push(guest.patron);
			}
		});
	}

	convertToNumber(event):number {  return +event; }

	editGuestInfo(guest, num){
		// let modal = this.modalCtrl.create(CoPatronSignupInfoModalPage, {ages: this.agesList, patron: this.newRegistrant.guests[num]});
		// modal.present();

		// modal.onDidDismiss(guest =>{
		// 	if (guest){
		// 		this.newRegistrant.guests.splice(num, 1, guest.patron);
		// 	}
		// });
		this.newRegistrant = {barcode: '', firstName: '', lastName: '', email: '', ageGroup: '', guests: [], isGuest: true};
		this.newRegistrant = guest;
		this.newRegistrant['position'] = num;
		console.log(guest);
		this.removeGuest(num);
	}
	addGuest(id, amount){
		this.guestTotal[id]+=amount;
		if(this.guestTotal[id]<=0){
			this.guestTotal[id]=0;
		}
  }
  cardCheckin(){
		if (this.newRegistrant.barcode.length <= 0) return;
		let loader = this.loading.create({content: "Retrieving info..."});
		loader.present();
		this.patronProvider.getSummaryDetails(this.newRegistrant.barcode).then(pat =>{
			loader.dismiss().catch(err=>{});
			if (pat && pat.id !== null){
				this.newRegistrant.barcode = pat.barcode;
				this.newRegistrant.firstName = pat.firstName;
				this.newRegistrant.lastName = pat.lastName;
				this.newRegistrant.email = pat.email;
			}
		});
	}
	updateRegistrantsList(silent?, event?){
		let loader = this.loading.create({content: "Retrieving registrants..."});
		if (!silent) loader.present();
		if (this.selectedEvent['registrationOpens']){ // FOR REGISTERED EVENTS updates the list, same as going to event checkin, will combine
			this.eventsProvider.getEventRegistrants(this.selectedEvent['eventId']).then(list =>{ //FIRST GET REGISTRATION LIST FROM EVENT
				this.eventsProvider.getEventAttendees(this.selectedEvent).then( regList =>{
					if (loader && !silent) loader.dismiss().catch(err=>{});
						this.registeredEventsAttendList = regList.getEventAttendance;
						// // console.log(list, regList);
						list = list.getEventRegistrants.map(r =>{  // LOOP THROUGH EVENT REGISTRANTS FIRST, GETTING CONTACT INFO
							let registrant = regList.getEventAttendance.find(l =>{return l.registrationId == r.registrationId}); //THEN FIND THE CORRESPONDING ATTENDEE TO MATCH THEM TOGETHER
							// console.log(registrant, r);
							r.ageGroup = this.agesList.find(a => {return a.nameSingular.toLowerCase() == r.age.toLowerCase()}).id;
							if (!r.guests) r.guests = [];
							if (registrant){
								if (registrant.id) r.attendanceId = registrant.id;
								r.checkedIn = registrant.checkedIn;
								r.barcode = registrant.libraryCard;
								r.firstName = registrant.firstName;
								r.lastName = registrant.lastName;
							}
							return r;
						});
						this.currentEventAttendanceList = list;
				});
			});
		} else { // UNREGISTERED EVENT, gets the attendance list from query, mapping the fields
			this.eventsProvider.getEventAttendees(this.selectedEvent['eventId']? this.selectedEvent : event).then(res =>{
				if (loader && !silent) loader.dismiss().catch(err=>{});
				res.getEventAttendance = res.getEventAttendance.filter(p =>{return p.checkedIn});
					this.currentEventAttendanceList = res.getEventAttendance.map(r =>{
						return {
							barcode: r.librarycard || r.libraryCard,
							firstName: r.firstName,
							lastName: r.lastName,
							email: r.email,
							ageGroup: this.agesList.find(a => {return a.nameSingular.toLowerCase() == r.age.toLowerCase()}).id,
							guests: r.guests || [],
							isGuest: r.masterId && r.masterId > 0,
							parentId: r.masterId || null,
							attendanceId: r.id
						};
					})
			});
		}
	}
	addToAttendanceGroup(){
		let patron = this.newRegistrant;
		if (patron['position'] >= 0){
			this.attendanceGroupList.splice(patron['position'], 0, patron);
		} else {
			this.attendanceGroupList.push(patron);
		}
		this.newRegistrant = {barcode: '', firstName: '', lastName: '', email: '', ageGroup: '', guests: [], isGuest: false};
	}
	checkinSinglePatron(){
		let patron = this.newRegistrant;
		this.attendanceGroupList.push(patron);
		this.checkinPatron();
	}
	checkinPatron(event?){
		if (this.selectedEvent['registrationOpens']) {

		if (this.newRegistrant.ageGroup > 0){ // #TODO Need to handle required info using their settings
		// if (this.newRegistrant.firstName.length > 0 && (this.newRegistrant.barcode.length > 0 || this.newRegistrant.isGuest) && this.newRegistrant.ageGroup > 0){
				//SECTION FOR REGISTERED EVENT
					//NEW REGISTRANT building the object, on success then adds to attendee list as well
					let reg = {};
					reg['type']= "new";
					reg['regType']=1;
					reg['id'] = 0;
					reg['age'] = this.agesList.find(a => {return a.id == this.newRegistrant.ageGroup}).nameSingular;
					reg['card'] = this.newRegistrant.barcode;
					reg['email'] = this.newRegistrant.email || "";
					reg['eventId'] = this.selectedEvent['eventId'];
					reg['phone'] = this.newRegistrant.phone || "";
					reg['customQuestions'] = [];
					reg['firstName'] = this.newRegistrant.firstName;
					reg['lastName'] = this.newRegistrant.lastName;
					reg['guests'] = this.newRegistrant.guests || [];
					this.eventsProvider.registerForEvent(reg, this.state.productType).then(regres =>{
						if (regres && regres.ok){
							this.eventsProvider.newAttendee(this.selectedEvent, this.newRegistrant, this.agesList).then(res=>{
								if (res && res.type == 'success'){
									this.toast.showAlert('',`${this.state.staff? 'Patron checked in!': 'Successfully checked in'}`,'success',2000).then(()=>{
										this.goToCheckinScreen(this.selectedEvent);
									});
								} else {
									this.toast.showAlert('',res.message || 'Error','warning',5000);
								}
							});
						} else {
							this.toast.showAlert('','Registrant not added','warning',5000);
						}
					});
				} else {
					this.toast.showAlert('','Please enter required info','warning',3000);
				}
			} else {
				let aArray = this.attendanceGroupList;
				let newAttendee = aArray.shift();
				newAttendee.guests = aArray.map((att, i) =>{
					att.isGuest = true;
					return att;
				});
				console.log(newAttendee);
					// new registrant non-registered event
				this.eventsProvider.newAttendee(this.selectedEvent, newAttendee, this.agesList).then(res=>{
					if (res && res.type == 'success'){
						this.toast.showAlert('',`${this.state.staff? 'Patron checked in!': 'Successfully checked in'}`,'success',2000).then(()=>{
							// this.goToRegistrantsList(true);
							this.getEvents(true);
							this.updateRegistrantsList(false, event);
						});
					} else {
						this.toast.showAlert('',res.message || 'Error','warning',5000);
					}
				});
				// console.log(newAttendee);
			}
	}
	checkInForAttendance(pat){
		//TOGGLES PATRON ATTENDANCE ON REGISTERED EVENT
		let loader = this.loading.create({content: "Updating attendance..."});
		loader.present();
		pat.checked = !pat.checked;
		this.eventsProvider.togglePatronAttendance(this.selectedEvent, pat).then(res =>{
			loader.dismiss().catch(err=>{});
			if (res.type == "success"){
				this.toast.showAlert('',res.message || 'Success','success', 5000);
				this.updateRegistrantsList(true);
			} else {
				pat.checkedIn = !pat.checkedIn;
				this.toast.showAlert('',res.error.text || 'Unable to checkin','warning');
			}
		});
	}
	bulkAddPatrons(event) {

		let bulk = this.popoverCtrl.create(CoBulkAddAttendancePopoverComponent, {ages: this.agesList, event: event}, {cssClass: "place-holds-popover"});
		bulk.present();

		bulk.onDidDismiss(data =>{
			if (data && data.ages && data.ages.length > 0){
				// console.log(data);
				let patrons = [];
				data.ages.forEach(g =>{
					if (g.adding > 0){
						for(let x = 0; x < g.adding ; x++){
							let patron = {
								firstName: "",
								lastName: "",
								email: "",
								librarycard: "",
								ageGroup: g.id,
								guests: []
							}
							patrons.push(patron);
						}
					}
				});
				console.log(patrons)
				Promise.all(patrons.map(patron =>{
					return this.eventsProvider.newAttendee(event, patron, this.agesList).then(r => r).catch(err => {return false});
				})
				).then(res =>{
					// console.log('all done', res);
					this.getEvents(true);
					this.updateRegistrantsList(true, event);
				})
			}
		});
		// this.eventsProvider.newAttendee(this.selectedEvent, this.newRegistrant, this.agesList).then(res=>{
		// 	if (res && res.type == 'success'){
		// 		this.toast.showAlert('','Patron checked in!','success',2000).then(()=>{
		// 			this.goToRegistrantsList();
		// 		});
		// 	} else {
		// 		this.toast.showAlert('',res.message || 'Error','warning',5000);
		// 	}
		// });

		// let loader = this.loading.create({content: "Updating attendance..."});
		// loader.present();
	}
	removeGuest(i){
		// if (!this.newRegistrant.guests[i].parentId){
		// 	this.newRegistrant.guests.splice(i, 1);
		// } else {
		// 	this.newRegistrant.guests[i]['deleted'] = !this.newRegistrant.guests[i]['deleted'];
		// }
		this.attendanceGroupList.splice(i, 1);
  }
  ngOnDestroy() {
    this.hidSubscription.unsubscribe();
    this.hidScanner.stop();
  }
  ionViewCanLeave(){
	  if(this.checkInStage==='choose'){
		  return true;
		}
		this.attendanceGroupList = [];
	  this.checkInStage='choose';
	  return false;
	}
	filterEvents(){
		this.eventList = this.rawEvents.filter(event =>{
			return event.title.toLowerCase().indexOf(this.searchTerm.toLowerCase())!== -1;
		})
		this.randomEvents = this.eventList;
	}
	ageGroupInfoRaw(event){
		if (!event.attendance) return event;
		let outputArray = [];
		let agesObj = event.attendance.reduce((red, e)=>{
			if (!e.age || !e.checkedIn) return red;
			if (!red[e.age]) red[e.age] = 0;
			red[e.age]++;
			return red
		}, {});
		if (!agesObj) return '';
		for (let key in agesObj){
			outputArray.push({name: key, count: agesObj[key]});
		}
		event.attendanceGrouped = outputArray;
		// console.log(event);
		return event;
	}
	getAgeGroupInfo(){
		let outHtml = [];
		let agesObj = this.currentEventAttendanceList.reduce((red, e)=>{
			if (!e.ageGroup) return {};
			if (!red[e.ageGroup]) red[e.ageGroup] = 0;
			red[e.ageGroup]++;
			return red
		}, {})
		this.currentEventAttendanceList.forEach(r =>{
			r.guests.forEach(g=>{
				if (!g.ageGroup) return;
				if (!agesObj[g.ageGroup]) agesObj[g.ageGroup] = 0;
				agesObj[g.ageGroup]++;
			});
		});
		if (!agesObj) return '';
		for (let key in agesObj){
			outHtml.push(`${agesObj[key]} ${this.agesList.find(a => {return a.id == key}).nameSingular}`)
		}
		if (outHtml.length > 0) return `(${outHtml.join(' / ')})`;
		return '';
	}
	getAgeGroup(id){
		if (id) return this.agesList.find(a =>{return a.id == id}).nameSingular;
		return '';
	}
	getGuestCount(){
		let num = this.currentEventAttendanceList.filter(r =>{return r.isGuest});
	}
	goToRegistrantsList(toDelete, event?){
		this.checkInStage = 'registrants';
		if(event) this.selectedEvent = event;
		this.currentEditPatronNumber = -1;
		if (toDelete) {
			this.newRegistrant = {barcode: '', firstName: '', lastName: '', email: '', ageGroup: '', guests: [], isGuest: false};
			this.attendanceGroupList = [];
		}
		this.updateRegistrantsList();
	}
	goBackToRegistrantScreen(){
		this.checkInStage = 'checkin';
		this.newRegistrant = {barcode: '', firstName: '', lastName: '', email: '', ageGroup: '', guests: [], isGuest: false};
		this.currentEditPatronNumber = -1;
	}
	editRegistrantInfo(reg, num){
		// if (!reg.isGuest) {
			// 	reg.guests = this.currentEventAttendanceList.filter(r => {return r.parentId && r.parentId == reg.attendanceId && r.parentId !== 0});
			// }
			this.currentEditPatronNumber = num;
			// this.checkInStage = 'checkin';
			const editPatron = reg;
			editPatron['position'] = num;
			this.newRegistrant = reg;
			this.newRegistrant['position'] = num;
			if (!this.newRegistrant.ageGroup) editPatron.ageGroup = '';
			if (!this.newRegistrant.barcode) editPatron.barcode = reg.libraryCard || '';

			let editModal = this.modalCtrl.create(CoPatronSignupInfoModalPage, {patron: editPatron, ages: this.agesList});
			editModal.present();

			editModal.onDidDismiss(data =>{
				if (data && data.patron){
					// this.goToRegistrantsList(false);
					this.newRegistrant = data.patron;
					this.checkinSinglePatron();
				} else {
					this.newRegistrant={barcode: '', firstName: '', lastName: '', email: '', ageGroup: '', guests: [], isGuest: false};
				}
			})
		this.oldPatronInfo = reg;
	}
	deletePatron(patron){
		this.toast.showGenericConfirm('Are you sure you want to delete this attendee?').then(answer =>{
			if (answer == 1){
				patron['deleted'] = true;
				// this.newRegistrant.guests.forEach(guest => {
				// 	guest['deleted'] = true;
				// });
				this.eventsProvider.newAttendee(this.selectedEvent, patron, this.agesList).then(res=>{
					if (res && res.type == 'success'){
						this.toast.showAlert('','Patron removed','success',2000).then(()=>{
							this.goToRegistrantsList(true);
						});
					} else {
						this.toast.showAlert('',res.message || 'Error','warning',5000);
					}
				});
			}
		})
	}

	closeFinder(logout:Boolean){
		if(logout){
			this.logout();
		}else{
		  this.state.nav.popToRoot();
		}
	}
	logout() {
		this.login.logout().then( done =>{
			if( done ){
				this.state.nav.popToRoot();
			}
		})
	}
}



// WEBPACK FOOTER //
// ./src/pages/co-event-checkin/co-event-checkin.ts